import { render, staticRenderFns } from "./MediasoupVideoConsumer.vue?vue&type=template&id=56ca78d8&"
import script from "./MediasoupVideoConsumer.vue?vue&type=script&lang=ts&"
export * from "./MediasoupVideoConsumer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports